

(function () {
  if (!/^\/collections\//.test(location.pathname)) return;

  const KEY = 'collection-scroll-y';

  window.addEventListener('pagehide', () => {
    sessionStorage.setItem(KEY, window.scrollY.toString());
  });

  window.addEventListener('pageshow', (ev) => {
    const saved = sessionStorage.getItem(KEY);
    if (saved !== null) {
      requestAnimationFrame(() => {
        window.scrollTo(0, Number(saved));
      });
    }
  });
})();
